import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DtcSibling } from '../../../../shared/models/dtc/dtc-sibling';
import { BaseReviewRequestPropagationModal } from './base-review-request-propagation-modal';
import { ReviewRequestSiblings } from '../../../../shared/models/review-requests/review-request-siblings';
import { AgentActionDirective } from '../../../directives/agent-action.directive';

@Component({
  selector: 'app-merge-review-propagation-modal',
  imports: [AgentActionDirective],
  templateUrl: './propagation-modal.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './propagation-modal.scss',
})
export class MergeReviewPropagationModal extends BaseReviewRequestPropagationModal {
  public override openModal(entityId?: string, dtcSiblings?: DtcSibling[]): void {
    this.callToActionDescription = 'You can merge similar review requests for siblings in other Sw Part Numbers';
    super.openModal(entityId, dtcSiblings);
  }

  protected execute(): void {
    if (!this.selectedOptionIds || this.selectedOptionIds.length < 1) {
      console.log('No SW Part Numbers selected for merging siblings');
      return;
    }

    const deleteReviewRequestSiblings: ReviewRequestSiblings = {
      parentReviewRequestId: this.entityId!,
      siblingReviewRequestTargets: this.mapSelectedSwPartNumbersToTargets(),
    };

    this.reviewRequestApi.mergeSiblings(deleteReviewRequestSiblings).subscribe({
      next: () => {
        this.toast.success('Successfully merged reviews requests for siblings in other SW Part Numbers');
        this.closeModal();
      },
      error: (err) => {
        console.log(err);
        this.toast.error('Failed to merge review requests in other SW Part Numbers');
      },
    });
  }
}
